import { twMerge } from 'tailwind-merge';

import { Locales } from 'constants/app';
import { setLocale } from 'store/app/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const localeStyles =
  'px-2 md:px-3 py-[5px] md:py-2 rounded-[6px] md:rounded-xsmall bg-transparent text-[12px] md:text-base text-white leading-5 font-normal';

const activeStyles = 'text-betCity-blue bg-white';

const SwitchLocale = () => {
  const { locale } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();

  const changeLocale = (language: string) => {
    localStorage.setItem('locale', language);
    window.location.hash = `#${language}`;
    dispatch(setLocale(language));
  };

  return (
    <>
      <button
        type="button"
        onClick={() => changeLocale(Locales.ru)}
        className={twMerge(localeStyles, locale === Locales.ru && activeStyles)}
      >
        RUS
      </button>
      <button
        type="button"
        onClick={() => changeLocale(Locales.kk)}
        className={twMerge(localeStyles, locale === Locales.kk && activeStyles)}
      >
        КAZ
      </button>
      <button
        type="button"
        onClick={() => changeLocale(Locales.en)}
        className={twMerge(localeStyles, locale === Locales.en && activeStyles)}
      >
        ENG
      </button>
    </>
  );
};

export { SwitchLocale };
